import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { FaChevronDown, FaChevronRight, FaTrash } from 'react-icons/fa';
import i18n from '@/utils/i18n';
import { DEFAULT_CONTAINER_TYPE_ICON } from '@/utils/imageUrl';
import { ContainerStationBasicInfoFragment } from '../../../../graphql/fragments/ContainerStationBasicInfo.generated';
import { useGetContainerStationWithContainersQuery } from '../../../../graphql/queries/containerStationWithContaienrs.generated';

type ContainerStationRowProps = {
  cs: ContainerStationBasicInfoFragment;
  removeItemsFromSession: (containerIds: string[], itemIds: string[]) => void;
  removingScannedItemsFromSession: boolean;

  scannedContainerCount: number;
  onTransferAllContainers: (containerStationId: string) => void;
  transferringContainers: boolean;
};

export const ContainerStationRow = ({
  cs,
  removeItemsFromSession,
  removingScannedItemsFromSession,
  scannedContainerCount,
  transferringContainers,
  onTransferAllContainers,
}: ContainerStationRowProps) => {
  const [expanded, setExpanded] = React.useState<boolean>(false);

  const { loading, data } = useGetContainerStationWithContainersQuery({
    variables: { id: cs.id },
    skip: !expanded,
  });

  return (
    <>
      <tr key={cs.id}>
        <td>
          <Link to={'/container-station/' + cs.id}>{cs.name}</Link>
        </td>
        <td>{cs.item_type.name}</td>
        <td>
          <Button
            className="btn-primary"
            disabled={scannedContainerCount === 0 || transferringContainers}
            onClick={() => onTransferAllContainers(cs.id)}
          >
            {transferringContainers ? (
              'Transferring...'
            ) : (
              <>
                Transfer all {scannedContainerCount} containers to {cs.name}
              </>
            )}
          </Button>
        </td>
        <td>
          <Button onClick={() => setExpanded(!expanded)}>
            {expanded ? <FaChevronRight /> : <FaChevronDown />}
          </Button>
        </td>
        <td>
          <Button
            className="btn-danger"
            onClick={() => {
              removeItemsFromSession([], [cs.id]);
            }}
            disabled={removingScannedItemsFromSession}
          >
            {removingScannedItemsFromSession ? '...' : <FaTrash />}
          </Button>
        </td>
      </tr>
      {expanded && (
        <tr key={cs.id + '_details'}>
          {loading ? (
            <td colSpan={4}>Loading...</td>
          ) : (
            <td colSpan={4}>
              {data?.containerStation.containers.length === 0 ? (
                <p>
                  {i18n.t(
                    'ScanTunnelSession:noContainersBookedToThisContainerStation',
                  )}
                </p>
              ) : (
                <>
                  <p>Currently booked containers on this container station:</p>
                  <Table>
                    <thead>
                      <tr>
                        <th></th>
                        <th>{i18n.t('ScanTunnelSession:name')}</th>
                        <th>{i18n.t('ScanTunnelSession:ownerSince')}</th>
                        <th>{i18n.t('ScanTunnelSession:status')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.containerStation.containers.map((c) => (
                        <tr key={c.id}>
                          <td>
                            <img
                              style={{ width: '50px', height: '50px' }}
                              alt={`container type ${c.type_id} ${c.type_name}`}
                              src={c.image_url || DEFAULT_CONTAINER_TYPE_ICON}
                            ></img>
                            <span className="pl-2">{c.type_name}</span>
                          </td>
                          <td>
                            <Link to={'/container/' + c.id}>{c.name}</Link>
                          </td>
                          <td>{c.owner_since}</td>
                          <td>{c.status}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </>
              )}
            </td>
          )}
        </tr>
      )}
    </>
  );
};
